import { Card } from '@foodsby/nutrient'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Article } from '../components/common/Layout'
import SimpleSpinner from '../components/common/SimpleSpinner'
import PanelLocation from '../components/profile/PanelLocation'
import PanelPaymentOptions from '../components/profile/PanelPaymentOptions'
import PanelPersonalInformation from '../components/profile/PanelPersonalInformation'
import PanelUpgrades from '../components/profile/PanelUpgrades'
import { loadLocationStart } from '../redux/modules/location'
import {
  changePasswordEditingMode,
  changePasswordStart,
  changePersonalInfoEditingMode,
  deletePaymentOptionStart,
  loadPaymentOptionsStart,
  loadProfileStart,
  updatePersonalInfoStart,
  updateProfilePictureStart,
} from '../redux/modules/profile'
import { selectCurrentLocationWithAddress, selectProfile } from '../redux/modules/selectors'

export class PageProfile extends Component {
  componentDidMount() {
    if (this.props.currentUser && !this.props.profile) {
      this.props.loadProfileStart(this.props.currentUser.userId)
      this.props.loadPaymentOptionsStart()
      this.props.loadLocationStart(this.props.currentUser.deliveryLocationId)
    } else if (this.props.currentUser && this.props.profile) {
      this.props.loadPaymentOptionsStart()
      this.props.loadLocationStart(this.props.currentUser.deliveryLocationId)
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.currentUser && !prevProps.profile && this.props.currentUser) {
      this.props.loadProfileStart(this.props.currentUser.userId)
      this.props.loadPaymentOptionsStart()
      this.props.loadLocationStart(this.props.currentUser.deliveryLocationId)
    }
  }

  render() {
    const {
      changePasswordEditingMode,
      changePasswordFailed,
      changePasswordStart,
      changePersonalInfoEditingMode,
      currentUser,
      deletePaymentOptionStart,
      isChangingPassword,
      isCurrentUserLoading,
      isEditingPersonalInfo,
      isLoadingPaymentOptions,
      isLoadingProfile,
      isLocationLoading,
      isUpdatingProfile,
      isWebpSupported,
      location,
      paymentOptions,
      profile,
      showSuccess,
      submitting,
      updatePersonalInfoStart,
      updateProfilePictureError,
      updateProfilePictureLoading,
      updateProfilePictureStart,
    } = this.props
    return (
      <Article>
        <Card>
          {isLoadingProfile || isLocationLoading ? (
            <SimpleSpinner />
          ) : (
            <PanelPersonalInformation
              changePasswordEditingMode={changePasswordEditingMode}
              changePasswordFailed={changePasswordFailed}
              changePasswordStart={changePasswordStart}
              changePersonalInfoEditingMode={changePersonalInfoEditingMode}
              isChangingPassword={isChangingPassword}
              isCurrentUserLoading={isCurrentUserLoading}
              isEditingPersonalInfo={isEditingPersonalInfo}
              isWebpSupported={isWebpSupported}
              profile={{ ...currentUser, ...profile }}
              submitting={submitting || isUpdatingProfile}
              success={showSuccess}
              updatePersonalInfoStart={updatePersonalInfoStart}
              updateProfilePictureError={updateProfilePictureError}
              updateProfilePictureLoading={updateProfilePictureLoading}
              updateProfilePictureStart={updateProfilePictureStart}
            />
          )}
        </Card>
        <Card className=" payment-options-table">
          {isLoadingPaymentOptions ? (
            <SimpleSpinner />
          ) : (
            <PanelPaymentOptions
              onDeletePaymentOption={deletePaymentOptionStart}
              paymentOptions={paymentOptions}
              submitting={submitting}
            />
          )}
        </Card>
        <Card>
          {isLoadingProfile || isLocationLoading ? (
            <SimpleSpinner />
          ) : (
            <PanelLocation isCurrentUserLoading={isCurrentUserLoading} location={location} />
          )}
        </Card>
        <PanelUpgrades location={location} />
        {/**
          * On hold while we sort out Employer end points
          *
          *  <Card>
          {isLoadingProfile || isLocationLoading ? (
            <SimpleSpinner />
          ) : (
            <PanelEmployer isCurrentUserLoading={isCurrentUserLoading} />
          )}
        </Card> */}
      </Article>
    )
  }
}

const mapStateToProps = state => {
  const {
    changePasswordFailed,
    isChangingPassword,
    isEditingPersonalInfo,
    isLoadingPaymentOptions,
    isLoadingProfile,
    paymentOptions,
    showSuccess,
    updateProfilePictureError,
    updateProfilePictureLoading,
  } = state.profile
  const { isLocationLoading } = state.location
  const location = selectCurrentLocationWithAddress(state)
  const { currentUser, isCurrentUserLoading, submitting } = state.user
  const { isUpdatingProfile } = state.profile
  const profile = selectProfile(state)
  const { isWebpSupported } = state.browser

  return {
    changePasswordFailed,
    currentUser,
    isChangingPassword,
    isCurrentUserLoading,
    isEditingPersonalInfo,
    isLoadingPaymentOptions,
    isLoadingProfile,
    isLocationLoading,
    isUpdatingProfile,
    isWebpSupported,
    location,
    paymentOptions,
    profile,
    showSuccess,
    submitting,
    updateProfilePictureError,
    updateProfilePictureLoading,
  }
}

const mapDispatchToProps = {
  changePasswordEditingMode,
  changePasswordStart,
  changePersonalInfoEditingMode,
  deletePaymentOptionStart,
  loadLocationStart,
  loadPaymentOptionsStart,
  loadProfileStart,
  updatePersonalInfoStart,
  updateProfilePictureStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageProfile)
